import http from "@/axiosConfig";
import toast from "@/global/ToastConfig";
import {saveAs} from "file-saver";
import downloadEndpoint from "@/endpoints/download/downloadEndpoint";
import {axiosFileExtensions} from "@/global/constants";

const integrationReports = {
    DOWNLOAD_NOVASOFT_REPORT: "/reports/overview-report/novasoft",
    DOWNLOAD_WORLDOFFICE_REPORT: "/reports/overview-report/worldOffice",
    DOWNLOAD_WORLDOFFICE_YOPAL: "/reports/overview-report/integrations/worldOffice-yp",
    DOWNLOAD_PACTIA_FIDUCIARY_ALLIANCE: "/reports/overview-report/integrations/fiduciaryAlliance-export",
    DOWNLOAD_PACTIA_FIDUCIARY_BANCOLOMBIA: "/reports/overview-report/integrations/fiduciaryBancolombia-export",
    DOWNLOAD_SHT_PRODUCTION: "/reports/overview-report/integrations/sht/production-export",
    DOWNLOAD_SHT_CLIENTS: "/reports/overview-report/integrations/sht/clients-export",
    DOWNLOAD_HELISA_TRANSACTIONS: "/reports/overview-report/integrations/helisa/transactions-export",
    DOWNLOAD_HELISA_THIRD_PARTIES: "/reports/overview-report/integrations/helisa/third-export",
    DOWNLOAD_CONTAI_NITS: "/reports/overview-report/integrations/contai/nits-export",
    DOWNLOAD_CONTAI_MOVEMENTS: "/reports/overview-report/integrations/contai/movements-export",
}
export default {
    downloadNovasoftReport(objParams) {
        return new Promise(resolve => {
            let newData = {code: -1};
            http.get(integrationReports.DOWNLOAD_NOVASOFT_REPORT, {
                params: objParams
            }).then(({data}) => {
                const code = data.code;
                if (code < 0) {
                    newData = data;
                    toast.error(data.message);
                    return;
                }
                newData = data;
            }).catch(() => toast.error("No se pudo realizar la conexión con el servidor"))
                .finally(() => resolve(newData));
        });
    },
    downloadWorldOfficeReport(objParams) {
        return new Promise(resolve => {
            let newData = {code: -1};
            http.get(integrationReports.DOWNLOAD_WORLDOFFICE_REPORT, {
                params: objParams
            }).then(({data}) => {
                const code = data.code;
                if (code < 0) {
                    newData = data;
                    toast.error(data.message);
                    return;
                }
                newData = data;
            }).catch(() => toast.error("No se pudo realizar la conexión con el servidor"))
                .finally(() => resolve(newData));
        });
    },
    downloadWorldOfficeYopal(objParams, fileName) {
        return downloadEndpoint.downloadFileByAxios(
            integrationReports.DOWNLOAD_WORLDOFFICE_YOPAL,
            axiosFileExtensions.XLSX.response,
            fileName,
            axiosFileExtensions.XLSX.extension,
            objParams
        );
    },
    downloadFiduciaryAlliance(objParams) {
        return new Promise(resolve => {
            let newData = {code: -1};
            http.get(integrationReports.DOWNLOAD_PACTIA_FIDUCIARY_ALLIANCE, {
                params: objParams
            }).then(({data}) => {
                const code = data.code;
                if (code < 0) {
                    newData = data;
                    toast.error(data.message);
                    return;
                }
                newData = data;
            }).catch(() => toast.error("No se pudo realizar la conexión con el servidor"))
                .finally(() => resolve(newData));
        });
    },

    downloadFiduciaryBancolombia(objParams, fileName) {
        const response = objParams.type === "xlsx"
            ? axiosFileExtensions.XLSX.response
            : axiosFileExtensions.TXT.response;
        const extension = objParams.type === "xlsx"
            ? axiosFileExtensions.XLSX.extension
            : axiosFileExtensions.TXT.extension
        return downloadEndpoint.downloadFileByAxios(
            integrationReports.DOWNLOAD_PACTIA_FIDUCIARY_BANCOLOMBIA,
            response,
            fileName,
            extension,
            objParams
        );
    },
    downloadProductionReport(objParams, fileName) {
        return downloadEndpoint.downloadFileByAxios(
            integrationReports.DOWNLOAD_SHT_PRODUCTION,
            axiosFileExtensions.XLSX.response,
            fileName,
            axiosFileExtensions.XLSX.extension,
            objParams
        );
    },
    downloadClientsReport(objParams, fileName) {
        return downloadEndpoint.downloadFileByAxios(
            integrationReports.DOWNLOAD_SHT_CLIENTS,
            axiosFileExtensions.XLSX.response,
            fileName,
            axiosFileExtensions.XLSX.extension,
            objParams
        );
    },
    downloadTransactionsReport(objParams, fileName) {
        return downloadEndpoint.downloadFileByAxios(
            integrationReports.DOWNLOAD_HELISA_TRANSACTIONS,
            axiosFileExtensions.XLSX.response,
            fileName,
            axiosFileExtensions.XLSX.extension,
            objParams
        );

    },
    downloadThirdPartiesReport(objParams, fileName) {
        return downloadEndpoint.downloadFileByAxios(
            integrationReports.DOWNLOAD_HELISA_THIRD_PARTIES,
            axiosFileExtensions.XLSX.response,
            fileName,
            axiosFileExtensions.XLSX.extension,
            objParams
        );
    },
    downloadContaiNitsReport(objParams, fileName) {
        return downloadEndpoint.downloadFileByAxios(
            integrationReports.DOWNLOAD_CONTAI_NITS,
            axiosFileExtensions.TXT.response,
            fileName,
            axiosFileExtensions.TXT.extension,
            objParams
        );
    },
    downloadContaiMovementReport(objParams, fileName) {
        return downloadEndpoint.downloadFileByAxios(
            integrationReports.DOWNLOAD_CONTAI_MOVEMENTS,
            axiosFileExtensions.TXT.response,
            fileName,
            axiosFileExtensions.TXT.extension,
            objParams
        );
    },
}